import { createContext, FC, PropsWithChildren, useContext } from 'react';

import { GroupConflict } from './groupConflicts';

export type TimetableGroupConflictsContextValue = {
  getGroupConflict: (groupId: string) => GroupConflict | undefined;
};

const TimetableGroupConflictsContext = createContext<TimetableGroupConflictsContextValue>({
  getGroupConflict: () => undefined,
});

export const TimetableGroupConflictsProvider: FC<
  PropsWithChildren<{ value: TimetableGroupConflictsContextValue }>
> = ({ value, children }) => (
  <TimetableGroupConflictsContext.Provider value={value}>
    {children}
  </TimetableGroupConflictsContext.Provider>
);

export const useGroupConflict = () => useContext(TimetableGroupConflictsContext);
